<div data-testid="work-order-unsaved-changes-dialog">
  <h2 mat-dialog-title>
    {{ 'UNSAVED_CHANGES' | translate }}

    <button
      [mat-dialog-close]="false"
      data-testid="work-order-unsaved-changes-dialog-close-btn"
      aria-label="close"
      mat-icon-button
      matSuffix
    >
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <div mat-dialog-content>
    <rs-font-light>{{ 'UNSAVED_CHANGES_IN_FOLLOWING_TABS' | translate: { tabs } }}</rs-font-light>
    <rs-font-light>{{ 'ARE_YOU_SURE_EXIT_WITHOUT_SAVING' | translate }}</rs-font-light>
  </div>

  <div mat-dialog-actions>
    <button
      [mat-dialog-close]="true"
      data-testid="work-order-unsaved-changes-exit-without-saving-btn"
      class="rs-btn--text"
      mat-button
    >
      {{ 'EXIT_WITHOUT_SAVING' | translate }}
    </button>

    <button
      [mat-dialog-close]="false"
      data-testid="work-order-unsaved-changes-back-btn"
      class="rs-btn--primary"
      mat-button
    >
      {{ 'BACK' | translate }}
    </button>
  </div>
</div>